export default __webpack_public_path__ + "static/media/Craggy_Kitchen2.f723e579.jpg";